export default __webpack_public_path__ + "static/media/GoogleIcon.1ddd0216.svg";